{
  "lookingUpCity": "Henter sted...",
  "cityNotFound": "Fant ingen poststed for dette postnummeret. Sjekk at det stemmer, eller skriv inn by manuelt.",
  "lookupFailed": "Kunne ikke hente poststed for dette postnummeret akkurat nå. Prøv igjen, eller skriv inn by manuelt."
}
